import { render, staticRenderFns } from "./Evalute.vue?vue&type=template&id=1e99bc75&scoped=true"
import script from "./Evalute.vue?vue&type=script&lang=ts"
export * from "./Evalute.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e99bc75",
  null
  
)

export default component.exports